import styled from 'styled-components';
import {GLOBAL_COLORS} from '../../util/colors';

const WBButton = styled.button`
  background: #f9f9f9 none;
  color: #363a3d;
  border: ${GLOBAL_COLORS.outline.toString()} 1px solid;
  border-radius: 2px;
  padding: 1px;
  cursor: pointer;

  outline-style: none;
  outline-width: 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #ececec;
    background-image: none;
    box-shadow: none;
    color: rgba(0, 0, 0, 0.8);
  }

  &:active {
    background-color: #dfdfdf;
    color: rgba(0, 0, 0, 0.9);
  }

  &:disabled,
  &:disabled:hover {
    color: #d2d2d2;
    border-color: #f4f4f4;
    background-color: #f9f9f9;
  }
`;

export default WBButton;
